export const uriToFile = async ( uri, fileName, type ) => {
  // Fetch the URI (data URL or blob URL) to get a blob
  const response = await fetch(uri);
  const blob = await response.blob();

  // Create a new File object from the blob
  return new File([blob], fileName, { type });
}
